<template>
    <div class="row">
        <div class="col-12">
            {{reduction_field?.date_txt}}
        </div>
    </div>
    
    <div class="row">
        <div class="col-4">
            Умови оплати (в тендері):
        </div>
        <div class="col-8">
            {{tender_payment}}
        </div>
    </div>
    
    <div class="row">
        <div class="col-4">
            Умови поставки (в тендері):
        </div>
        <div class="col-8">
            {{tender_delivery}}
        </div>
    </div>
    
    <div class="row">
        <div class="col-4">
            Строк поставки (в тендері):
        </div>
        <div class="col-8">
            {{tender?.date_delivery}}
        </div>
    </div>
    
    <div class="row">
        <div class="col-4">
            Валюта торгів:
        </div>
        <div class="col-8">
            {{currency}}
        </div>
    </div>
</template>

<script>
export default {
    name: "reduction_head",
    props : {
        protocol : {
            type : Object,
            required : true,
        }
    },
    
    computed : {
        tender () {
            return this.protocol.tender;
        },
        
        reduction_field() {
            return this.tender?.reduction_param;
        },
        
        tender_payment() {
            return this.tender?.payment_name;
        },
        
        tender_delivery() {
            return this.tender?.delivery_name;
        },
        
        currency() {
            return this.tender?.currency_name;
        }
    }
}
</script>



<style scoped>

</style>